<template>
<div class="chapter">
<div class="inner_page">
<p class="PN" id="pt001"><a id="page_1"></a><a href="#/xhtml/contents#pt-001"><span class="small">PART I</span></a></p>
<p class="PT"><a href="#/xhtml/contents#pt-001">Ending Most Hunger<br/>Is within Reach</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?0e176e72